import request from '@/utils/request'

// 查询合同管理列表
export function listFailContract(query) {
  return request({
    url: '/cont/fail/contract/list',
    method: 'get',
    params: query
  })
}

// 查询合同管理详细
export function getFailContract(contractId) {
  return request({
    url: '/cont/fail/contract/' + contractId,
    method: 'get'
  })
}

// 新增合同管理
export function addContract(data) {
  return request({
    url: '/cont/fail/contract',
    method: 'post',
    data: data
  })
}

// 修改合同管理
export function updateFailContract(data) {
  return request({
    url: '/cont/fail/contract',
    method: 'put',
    data: data
  })
}

// 删除合同管理
export function delContract(contractId) {
  return request({
    url: '/cont/fail/contract/' + contractId,
    method: 'delete'
  })
}

// 导出合同管理
export function exportContract(query) {
  return request({
    url: '/cont/fail/contract/export',
    method: 'get',
    params: query
  })
}

